import { isBrowser } from 'utils/browser';

export const getPathForQuery = () => {
  const pathname: string | undefined = isBrowser() ? window.location.pathname : undefined;
  const isEndWithSeparator = pathname?.trim().endsWith('/');

  return isEndWithSeparator ? pathname?.trim().slice(0, -1) : pathname?.trim();
};
